import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

// Gold-leaf shimmer that periodically sweeps across a CTA.
// Parent must be relative + overflow-hidden.
const Shimmer: React.FC = () => {
  const reduceMotion = useReducedMotion();
  if (reduceMotion) return null;
  return (
    <motion.span
      aria-hidden="true"
      className="absolute top-0 h-full w-1/2 pointer-events-none"
      style={{
        background:
          'linear-gradient(105deg, transparent, rgba(255,246,220,0.5), transparent)',
      }}
      initial={{ left: '-75%' }}
      animate={{ left: ['-75%', '-75%', '125%'] }}
      transition={{ duration: 5.5, times: [0, 0.72, 1], repeat: Infinity, ease: 'easeInOut' }}
    />
  );
};

export default Shimmer;
